/**
 * @module surveys ui
 */
import { createReducer } from '@reduxjs/toolkit';
import { surveyElementActions } from '~/behaviors/actions/survey_element.action';
import { surveyActions } from '~/behaviors/actions/survey.actions';
import { metaActions } from '~/behaviors/actions/meta.actions';
import { legacySurveyActions } from '~/behaviors/actions/legacy_survey.actions';

const defaultState = {
  isLoadingSurveyNames: false,
  isLoadingSurvey: false,
  isLoadingLegacySurveys: false,
  isLoadingLibraryQuestions: false,
  isLoadingTrendQuestions: false,
  isLoadingDeleteSurvey: false,
  isLoadingDuplicateSurvey: false,
  isLoadingCancelSurvey: false,
  isLoadingSurveyData: false,
};

const reset = () => defaultState;

const merge = (updates) => (state) => ({
  ...state,
  ...updates,
});

const surveysUI = createReducer(defaultState, (builder) => {
  builder
    .addCase(metaActions.reset, reset)
    .addCase(surveyActions.fetchBasicSurveyList.pending, merge({ isLoadingSurveyNames: true }))
    .addCase(surveyActions.fetchBasicSurveyList.fulfilled, merge({ isLoadingSurveyNames: false }))
    .addCase(surveyActions.fetchBasicSurveyList.rejected, merge({ isLoadingSurveyNames: false }))
    .addCase(surveyActions.fetchSurveyWithSurveyElements.pending, merge({ isLoadingSurvey: true }))
    .addCase(surveyActions.fetchSurveyWithSurveyElements.fulfilled, merge({ isLoadingSurvey: false }))
    .addCase(surveyActions.fetchSurveyWithSurveyElements.rejected, merge({ isLoadingSurvey: false }))
    .addCase(surveyElementActions.getLibraryQuestions.pending, merge({ isLoadingLibraryQuestions: true }))
    .addCase(surveyElementActions.getLibraryQuestions.fulfilled, merge({ isLoadingLibraryQuestions: false }))
    .addCase(surveyElementActions.getLibraryQuestions.rejected, merge({ isLoadingLibraryQuestions: false }))
    .addCase(surveyElementActions.getTrendQuestions.pending, merge({ isLoadingTrendQuestions: true }))
    .addCase(surveyElementActions.getTrendQuestions.fulfilled, merge({ isLoadingTrendQuestions: false }))
    .addCase(surveyElementActions.getTrendQuestions.rejected, merge({ isLoadingTrendQuestions: false }))
    .addCase(legacySurveyActions.fetchDashboardSurvey.pending, merge({ isLoadingLegacySurveys: true }))
    .addCase(legacySurveyActions.fetchDashboardSurvey.fulfilled, merge({ isLoadingLegacySurveys: false }))
    .addCase(legacySurveyActions.fetchDashboardSurvey.rejected, merge({ isLoadingLegacySurveys: false }))
    .addCase(surveyActions.deleteSurvey.pending, merge({ isLoadingDeleteSurvey: true }))
    .addCase(surveyActions.deleteSurvey.fulfilled, merge({ isLoadingDeleteSurvey: false }))
    .addCase(surveyActions.deleteSurvey.rejected, merge({ isLoadingDeleteSurvey: false }))
    .addCase(surveyActions.duplicateSurvey.pending, merge({ isLoadingDuplicateSurvey: true }))
    .addCase(surveyActions.duplicateSurvey.fulfilled, merge({ isLoadingDuplicateSurvey: false }))
    .addCase(surveyActions.duplicateSurvey.rejected, merge({ isLoadingDuplicateSurvey: false }))
    .addCase(surveyActions.cancelSurveySchedule.pending, merge({ isLoadingCancelSurvey: true }))
    .addCase(surveyActions.cancelSurveySchedule.fulfilled, merge({ isLoadingCancelSurvey: false }))
    .addCase(surveyActions.cancelSurveySchedule.rejected, merge({ isLoadingCancelSurvey: false }))
    .addCase(surveyActions.migrateSurvey.pending, merge({ isLoadingSurveyData: true }))
    .addCase(surveyActions.migrateSurvey.fulfilled, merge({ isLoadingSurveyData: false }))
    .addCase(surveyActions.migrateSurvey.rejected, merge({ isLoadingSurveyData: false }));
});

export default surveysUI;
